<div class="sales-volume-view" fxLayout="row" fxLayoutGap="5px">
  <span>{{value}}</span>
  <mtn-sales-volume-tag *ngIf="!!volume && includeSuffix" [volume]="volume"></mtn-sales-volume-tag>
  <span class="color-muted" *ngIf="value && includeSuffix">({{suffix}}) {{volumeDate}}</span>
</div>
